import { render } from 'react-dom';
import API from './api/api';
import { asyncWithLDProvider, LDSingleKindContext } from 'launchdarkly-react-client-sdk';
import { ProviderConfig } from 'launchdarkly-react-client-sdk';
import { getLaunchDarklyEnvId } from './services/launchDarkly/config';
import Identity from './components/Identity/Identity';
import { BrowserRouter } from 'react-router-dom';
import { parseSubscriberId } from './util/helpers';
import { EQueryStringParam } from './util/constants';

// get subscriberId from the URL
const subscriberId = parseSubscriberId();

// setup react app mount element
const mount = document.createElement('div');
mount.setAttribute('data-name', 'identity');
document.body.appendChild(mount);

// base launch darkly config
const launchDarklyConfig: ProviderConfig = {
    clientSideID: getLaunchDarklyEnvId(),
    context: { kind: 'user', key: '1', ...(subscriberId && { subscriberId }) } as LDSingleKindContext,
};

(async () => {
    if (subscriberId) {
        try {
            // send additional business config values to launch darkly if they exist for the subscriber
            const loginInfoResponse = await API.get.loginInfo(`?${EQueryStringParam.subscriberId}=${subscriberId}`);
            const { regionId, customerBrandId, customerAccountId } = loginInfoResponse.data;
            launchDarklyConfig.context = {
                ...launchDarklyConfig.context,
                ...launchDarklyConfig.context.custom,
                ...(regionId && { regionId: regionId.toString() }),
                ...(customerBrandId && { customerBrandId }),
                ...(customerAccountId && { customerAccountId }),
            };
        } catch {
            console.error('Failed to get login info -- pre app mount');
        }
    }

    // initialize Launch Darkly
    const LDProvider = await asyncWithLDProvider({
        ...launchDarklyConfig,
    });

    // render react app
    render(
        <LDProvider>
            <BrowserRouter>
                <Identity />
            </BrowserRouter>
        </LDProvider>,
        mount,
    );
})();
